"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var constants_1 = require("../data/constants");
var Schedule = require("./timezone");
var localSchedule = function (expert) { return Schedule.scheduleToCurrentDates(expert.schedule, expert.timezone, expert.timezone_offset); };
var todaySchedule = function (expert) { return localSchedule(expert)[(new Date()).getDay()]
    .find(function (d) { return d["from"] < new Date() && d["to"] > new Date(); }); };
exports.todaySchedule = todaySchedule;
var nextSchedule = function (expert) { return localSchedule(expert)
    .reduce(function (a, b) { return a.concat(b); })
    .sort(function (a, b) { return a["from"] - b["from"]; })
    .find(function (e) { return e["from"] > new Date(); }); };
exports.nextSchedule = nextSchedule;
var available = function (expert) {
    if (expert.current_pause) {
        return false;
    }
    if (expert.last_active_call) {
        return false;
    }
    var today = localSchedule(expert)[(new Date()).getDay()];
    if (!today) {
        return false;
    }
    return !!today.find(function (d) { return d["from"] < new Date() && d["to"] > new Date(); });
};
exports.available = available;
var isRestricted = function (expert) { return expert.role === "restricted"; };
exports.isRestricted = isRestricted;
var deprecate = function (method, result) {
    console.warn("[DEPRECATED] expert." + method + "() is now deprecated, use Expert." + method + "(expert) instead");
    return result;
};
var processExpert = function (expert) { return Object.assign({}, expert, {
    localSchedule: localSchedule(expert),
    todaySchedule: function () { return deprecate("todaySchedule", todaySchedule(expert)); },
    nextSchedule: function () { return deprecate("nextSchedule", nextSchedule(expert)); },
    available: function () { return deprecate("available", available(expert)); },
    isRestricted: function () { return deprecate("isRestricted", isRestricted(expert)); },
}); };
var all = function (page) {
    if (page === void 0) { page = 1; }
    return Request.sendGet(constants_1.endpoints.api + "/experts")
        .then(function (experts) { return experts.map(processExpert); });
};
exports.all = all;
var get = function (id) {
    return Request.sendGet(constants_1.endpoints.api + "/experts/" + id)
        .then(processExpert);
};
exports.get = get;
//# sourceMappingURL=expert.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/expert.js
// module id = 907
// module chunks = 3